<div  class="modal fade" id="blocking-banner-modal" role="dialog" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': this.universalService.showBlockingBannerModal ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <!-- .cards.length >= 1 -->
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content h-90" [ngClass]="!this.universalService.isMobileDevice && this.bannerToDisplay[0]?.cardData?.cardType == 'FULLSCREEN_IMAGE' ? 'full-width' : ''">
      @if (this.bannerToDisplay[0]?.cardData?.userRemovable == true) {
        <div class="modal-header border-bottom-0 p-0">
          <button type="button" class="close btn-pos blocking-banner-close" data-dismiss="modal" (click)="closeBanner(this.bannerToDisplay[0]?.cardUniqueCode);">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        </div>
      }
      <div class="modal-body border-bottom-0" [ngClass]="this.bannerToDisplay[0]?.cardData?.cardType == 'FULLSCREEN_IMAGE' ? 'p-0' : ''">
        @if (this.bannerToDisplay[0]?.cardData?.cardType ==  'ALERT_BUTTON_HYPERLINK' ) {
          <div class="banner-content mt-1">
            <span class="NeueOrder-History icon-cont"></span>
            <h5 class="mt-4">{{this.bannerToDisplay[0]?.cardData?.displayData?.titleText}}</h5>
            <p id="bannerDes">{{this.bannerToDisplay[0]?.cardData?.displayData?.description}}</p>
          </div>
        }
        @if (this.bannerToDisplay[0]?.cardData?.cardType == 'FULLSCREEN_IMAGE') {
          <div class="banner-content mt-0" >
            @if (!this.universalService.isMobileDevice) {
              <a rel="noopener noreferrer" (click)="fullScreenImgBannerRedirection(this.bannerToDisplay[0]?.cardData?.actionUrl,this.bannerToDisplay[0]?.cardUniqueCode)">
                <img src="{{this.bannerToDisplay[0]?.cardData?.staticImgUrl}}" class="img-resposive"/>
              </a>
            }
            @if (this.universalService.isMobileDevice) {
              <a (click)="fullScreenImgBannerRedirection(this.bannerToDisplay[0]?.cardData?.actionUrl,this.bannerToDisplay[0]?.cardUniqueCode)">
                <img src="{{this.bannerToDisplay[0]?.cardData?.staticImgUrlMob}}" class="img-resposive"/>
              </a>
            }
          </div>
        }
      </div>
      @if (this.bannerToDisplay[0]?.cardData?.cardType ==  'ALERT_BUTTON_HYPERLINK' ) {
        <div class="modal-footer border-top-0 p-3" >
          <div class="banner-btn-main">
            <button class="mr-3 banner-btn" (click)="bannerAction(this.bannerToDisplay[0]?.cardData?.userRemovable,this.bannerToDisplay[0]?.cardUniqueCode);">{{this.bannerToDisplay[0]?.cardData?.displayData?.actions[0]?.buttonTitle}}</button>
          </div>
        </div>
      }
    </div>
  </div>
</div>